module.exports = __webpack_public_path__ + "static/media/arrow_b.33b171ba.svg";